import { Helmet, HelmetProvider } from "react-helmet-async";
import AuthLayout from "../blocs/AuthLayout";

import LoginForm from "./auth/loginForm";

const Login = () => {
  const title =
    "Réservez tous vos <strong>services pros </strong>, quand et où vous voulez.";
  return (
    <AuthLayout image={"../images/Twyny_Connexion.jpg"} title={title}>
      <HelmetProvider>
        <Helmet>
          <title>Connexion </title>
          <meta name="description" content="Page authentification  " />
        </Helmet>
      </HelmetProvider>
      <LoginForm />
    </AuthLayout>
  );
};

export default Login;
